import { datadogLogs } from '@datadog/browser-logs';
import { ModalContainer, useKeyPressed } from '@welbe/web-design-system';
import { ModalHasActiveUser } from 'App/Components/ModalHasActiveUser/ModalHasActiveUser';
import { useExpiredSession } from 'hooks/useExpiredSession';
import { useSessionStorage } from 'hooks/useSessionStorage';
import { ReactNode, createContext, useState } from 'react';

export const GlobalContext = createContext({});

type GlobalProviderProps = {
	children: ReactNode;
};

export const GlobalProvider = ({
	children,
}: GlobalProviderProps): JSX.Element => {
	const { getSessionStorage } = useSessionStorage();
	const [infoFocused, setInfoFocused] = useState<any>({});
	const {
		activeSession,
		modalIsOpen,
		handleCloseModalExpiredSession,
		handleLogout,
	} = useExpiredSession();

	const handleCaptureKey = (action: 'save' | 'print') => {
		const currentUser = JSON.parse(getSessionStorage('me') || '{}');

		datadogLogs.logger.info('telemedicine', {
			type: 'info',
			action: action,
			focusedElement: infoFocused,
			selectedCompany: currentUser?.company?.fancyName,
			doctor: currentUser?.email,
			browserDate: new Date().toLocaleString(),
			path: location.pathname,
		});
	};

	useKeyPressed(['ctrl', 's'], () => handleCaptureKey('save'));
	useKeyPressed(['ctrl', 'p'], () => handleCaptureKey('print'));

	return (
		<>
			<GlobalContext.Provider
				value={{
					activeSession,
					setInfoFocused,
				}}
			>
				{children}
			</GlobalContext.Provider>
			{modalIsOpen && (
				<ModalContainer
					visible={modalIsOpen}
					zIndex={9999}
					onClose={handleCloseModalExpiredSession}
					closeOnlyOnTheButton
					height="auto"
				>
					<ModalHasActiveUser
						activeSession={activeSession}
						handleClose={handleCloseModalExpiredSession}
						handleLogout={handleLogout}
					/>
				</ModalContainer>
			)}
		</>
	);
};
